const doc = [({"ja":({"travelPeriods":"旅行期間", "destinations":"目的地"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;